import type { AccountingSummary } from "@/utils/accounting";
import { formatCOP } from "@/utils/format";

const AccountingStats = ({ summary }: { summary: AccountingSummary }) => {
  const cards = [
    {
      icon: "ri-safe-2-line",
      label: "Capital en inventario",
      value: formatCOP(summary.capitalCost),
      hint: `PVP valorado ${formatCOP(summary.inventoryPublicValue)}`,
      bubble: "bg-primary-500/25 text-primary-100",
    },
    {
      icon: "ri-line-chart-line",
      label: "Ingresos reconocidos",
      value: formatCOP(summary.recognizedIncome),
      hint: "Ventas cerradas + consignaciones pagadas",
      bubble: "bg-accent-500/20 text-accent-200",
    },
    {
      icon: "ri-hand-coin-line",
      label: "Ganancia estimada",
      value: formatCOP(summary.realizedProfit),
      hint: "Directas + red de asesores",
      bubble: "bg-secondary-500/25 text-secondary-200",
    },
    {
      icon: "ri-wallet-3-line",
      label: "Por cobrar",
      value: formatCOP(summary.advisorDebt + summary.clientReceivable),
      hint: `Asesores ${formatCOP(summary.advisorDebt)} · Clientes ${formatCOP(summary.clientReceivable)}`,
      bubble: "bg-accent-500/15 text-accent-100",
    },
  ];

  return (
    <div className="grid grid-cols-2 xl:grid-cols-4 gap-3 md:gap-4">
      {cards.map((c) => (
        <div key={c.label} className="glass-panel rounded-lg p-4 animate-fade-up">
          <span className={`w-9 h-9 rounded-lg flex items-center justify-center ${c.bubble}`}>
            <i className={`${c.icon} text-lg`} />
          </span>
          <p className="text-[11px] text-foreground-500 mt-3">{c.label}</p>
          <p className="text-lg md:text-xl font-heading font-extrabold text-foreground-950 mt-0.5 break-words">
            {c.value}
          </p>
          <p className="text-[10px] text-foreground-500 mt-1">{c.hint}</p>
        </div>
      ))}
    </div>
  );
};

export default AccountingStats;